export default __webpack_public_path__ + "static/media/banner.309d1c62.jpg";